import { render, staticRenderFns } from "./CheckDiscountActivity.vue?vue&type=template&id=0d8f44d0&scoped=true&"
import script from "./CheckDiscountActivity.vue?vue&type=script&lang=js&"
export * from "./CheckDiscountActivity.vue?vue&type=script&lang=js&"
import style0 from "./CheckDiscountActivity.vue?vue&type=style&index=0&id=0d8f44d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f44d0",
  null
  
)

export default component.exports